export default {
  partNoPlaceholder: 'Enter Part No',
  header: 'Please enter',
};
